import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import { DEFAULT_NAMESPACES, PRODUCERS_NAMESPACES, SIMULATION_NAMESPACES } from 'constants/i18n'
import Simulation from 'features/simulation/Simulation'

const SimulationPage = () => {
  return <Simulation />
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, ...SIMULATION_NAMESPACES, ...PRODUCERS_NAMESPACES], i18nConfig))
    }
  }
}

export default SimulationPage
